import { Box, Button, IconButton, Tooltip } from '@mui/material'
import { DOWNLOAD_FILES_COLUMNS } from '../../../../constants/returnsStep'
import { CommonTable } from '../../../common'
import { downloadReturnsFile } from '../../../../api/returnsStep'
import { saveBlobAsFile } from '../../../../api/apiUtils'
import { useState } from 'react'

function DownloadFiles({
  dowloadFileList,
  defaultSearchCOList,
  currentPage,
  itemsPerPage,
  tanMasterUuid
}) {

  const [isDownload,setIsDownload] = useState(false)
  
  const handleDownloadFile = async data => {
    setIsDownload(true)
    const { entityTan, entityName, returnType, formType, quarter, financialYear } =
        defaultSearchCOList || {}
    const payload = {
      pageFilter: {
        includeCount: false,
        currentPage: currentPage,
        pageSize: itemsPerPage,
        sortField: 'entityTAN',
        sortOrder: 'DESC',
      },
      tanUuid: tanMasterUuid,
      entityTAN: entityTan,
      entityName,
      returnType: returnType?.toUpperCase(),
      formType: formType,
      quarter,
      financialYear: financialYear,
    }
    const resp = await downloadReturnsFile(payload,data.uuid)
    if(resp.success){
      saveBlobAsFile(resp.data, `${data?.fileName}`);
    }
    setIsDownload(false)
  }

  const renderActions = (value, row) => {
    return <Tooltip title={row.fileName}>
      <Button disabled={isDownload} sx={{ color: '#CF6210',}} onClick={() => handleDownloadFile(row)}>
      {row.fileName}
    </Button>
    </Tooltip>
  }

  // Add actions column to the download columns
  const columnsWithActions = [
    ...DOWNLOAD_FILES_COLUMNS,
    {
      id: 'fileName',
      label: 'File Name',
      width: '300px',
      render: renderActions,
    },
  ]

  return (
    <CommonTable
      columns={columnsWithActions}
      data={dowloadFileList}
      showActions={false}
      emptyMessage="No data found"
    />
  )
}

export default DownloadFiles
